import { baseEntitySchema } from '../entity.js'
import * as z from 'zod'

export const chatSchema = baseEntitySchema.extend({
  type: z.literal('chat'),
  /**
   * An anchored thread, resolved (GH #3041). Left undefined, the legacy rule applies: resolved when all its comments
   * are. `false` is an explicit reopen, so it must never get a default
   */
  resolved: z.boolean().describe('The thread is resolved; undefined means use the legacy rule').optional(),
  resolvedBy: z.string().describe('Who resolved the thread').optional(),
  resolvedAt: z.string().describe('When the thread was resolved').optional(),
  /** A block's comment thread lives under its document, anchored to the block (as notes are, #2883) */
  targetElementId: z.string().describe('The block this thread is anchored to in its parent document').optional(),
})

export function isChat(node: unknown): node is z.infer<typeof chatSchema> {
  return chatSchema.safeParse(node).success
}

/** A block's comment thread, not a standalone chat: kept out of lists that aren't about comments */
export function isAnchoredChat(node: unknown): node is z.infer<typeof chatSchema> & { targetElementId: string } {
  return isChat(node) && typeof node.targetElementId === 'string' && node.targetElementId.length > 0
}

export type Chat = z.infer<typeof chatSchema>

/** Chat fields only the server writes, through the chat-actions endpoint: a PATCH or a create drops them */
export const serverOwnedChatFields = ['resolved', 'resolvedBy', 'resolvedAt'] as const

export default chatSchema
